const InputField = ({ lable, id, name, value, onChange }) => {
  return (
    <div className="mb-3 border p-2">
      <label className="form-label">{lable}</label>
      <input
        type="number"
        className="form-control"
        onWheel={(e) => e.target.blur()}
        id={id}
        name={name}
        value={value}
        onChange={onChange}
      />
    </div>
  );
};

export default InputField;
